import styled , {css} from 'styled-components'

function trOpacity(){
    let styles = '';

    for (let i = 1; i < 31; i +=1){
        styles +=`
            :nth-child(${i}){
                opacity: 0;
                animation: bgopa .5s ${0.03*i}s forwards;
            }
        `
    }
    return css`${styles}`;
}


export const Styles = styled.div`
  /* padding: 1rem; */
  /* padding-bottom: 100px; */
  /* border: black solid; */
  position: absolute;
  width: 100%;
    transition: .5s;

    @keyframes bgopa{
        0%{opacity: 0;}
        100%{opacity: 1;}
    }

    button{
        margin: 10px;
        padding: 7px;
        border: 1px solid rgba(150, 150, 150, 0.4);
        border-radius: 10px;
        color: white;
        cursor: pointer;
        background-color: transparent;
        transition: .2s;
        :hover{
            background-color: rgba(150, 150, 150, 0.2);
        }
        :active{
            background-color: rgba(150, 150, 150, 0.4);
        }
    }

    div{
        /* margin: 10px; */
        span{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            > input[type="checkbox"]{
                    position: absolute;
                    opacity: 0;
                    
                    :checked + label{
                        border: rgba(46, 88, 142, 1) 1px solid;
                        border-radius: 5px;
                        padding: 5px 10px;
                        margin: 10px;
                        background-color: rgba(46, 88, 142, 1);
                        cursor: pointer;
                        transition: .3s;
                    }
                    > label{
                        border: rgba(46, 88, 142, 1) 1px solid;
                        border-radius: 5px;
                        padding: 5px 10px;
                        margin: 10px;
                        cursor: pointer;
                        transition: .3s;
                    }
                }
                
                label{
                    border: rgba(46, 88, 142, 1) 1px solid;
                    border-radius: 5px;
                    padding: 5px 10px;
                    margin: 10px;
                    cursor: pointer;

                    transition: .3s;
                    
                }
        }
    }

  
  #table-div{
      /* display: flex;
      align-items: center;
        justify-content: center; */
        #table-input{
            margin-left: 10px;
            width: 250px;
            input{
                    /* background-color: transparent; */
                    border: 1px solid grey !important;
                    border-radius: 5px;
                    padding: 2px;
                    color: black;
                    width: 300px;
                    background-color:rgba(255, 255, 255, .05);
                    user-select:none;
                    outline: none;
                    /* max-width: 120px; */
                }
        }
        
        table {
            /* border: red solid; */
            animation: bgopa .5s forwards;
            /* border-top: 1px solid grey; */
            /* border-bottom: 1px solid grey; */
            border-spacing: 0;
            /* border: 1px solid grey; */
            
            /* transition: .5s; */
            user-select: text;
            position: absolute;
            margin-top: 10px !important;
            margin-bottom: 20px !important;
            /* scroll-margin-bottom: 100px;
            -webkit-margin-bottom-collapse: 100px; */
            width: 100%;
            /* margin-right: 5vw;
            margin-left: 5vw; */

            

            
            

            * {
                /* margin:0;padding:0;border:0 none;position: relative;  */
                outline: none;
                *:after, *:before{
                    box-sizing: border-box;
                -moz-box-sizing: border-box;
                }
            }

            /* a{
                line-height: 2;

                :before{
                    content: "";
                    position: absolute;

                    width: 160%;
                    height: 2px;
                    bottom: -5px;
                    left: -30%;
                    
                    background: rgba(144, 45, 19, 1);
                    visibility: hidden;
                    border-radius: 5px;
                    transform: scaleX(0);
                    transition: .15s linear;
                }
                :hover:before, focus:before{
                    visibility: visible;
                    transform: scaleX(.75);
                }
            } */

            tr {
                

                
                
                :last-child {
                    td {

                    border-bottom: 0;
                    }
                }
            }

            thead{
                user-select: none;
                border: none;
                tr{  
                    :first-child{
                        
                        font-size:1.1rem;
                        /* background-color: rgba(144, 45, 19, 1); */
                        /* background-color: rgba(223, 142, 19, 1); */
                    }
                    
                }
            }  

            tbody{
                tr{
                    
                    /* opacity: 0; */
                    ${trOpacity()}
                    
                    :nth-child(2){
                        
                    }
                    :hover{
                        background-color: rgba(0, 0, 0, 0.1);
                        transition: .2s;
                    }
                    td{
                        position: relative;
                        >a{
                            
                            position: absolute;
                            padding: 0;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            text-decoration: none;
                            color: whitesmoke;
                        }
                    }
                    
                }
                td{
                    >div{
                        display: flex;
                        justify-content:center;
                        >button{
                            
                        }
                    }
                    padding-bottom: 20px;
                    padding-top: 20px;
                    >a{
                        text-decoration: none;
                        color: whitesmoke;
                    }
                    :first-child{
                        /* border-left: 1px solid grey; */
                        /* padding: 0 !important; */
                        min-width: 20px;
                        div{
                            /* width: 30px;
                            height: 30px; */
                            /* border: red solid; */
                            /* padding: 0 !important; */
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            

                            >input[type="checkbox"]{
                                position: absolute;
                                top: 0;
                                opacity: 0;
                                
                                :checked + label{
                                    border: rgba(255, 255, 255, 1) 1px solid;
                                    border-radius: 20px;
                                    width: 15px;
                                    height: 15px;
                                    /* padding: 5px 10px;
                                    margin: 10px; */
                                    background-color: rgba(255, 255, 255, 1);
                                    cursor: pointer;
                                    transition: .1s;
                                }
                                > label{
                                    border: rgba(255, 255, 255, .8) 1px solid;
                                    border-radius: 20px;
                                    width: 13px;
                                    height: 13px;
                                    background-color: rgba(255, 255, 255, .1);
                                    /* padding: 5px 10px;
                                    margin: 10px; */
                                    cursor: pointer;
                                    transition: .1s;
                                }
                            }
                            >label{
                                border: rgba(255, 255, 255, .8) 1px solid;
                                border-radius: 20px;
                                width: 13px;
                                height: 13px;
                                background-color: rgba(255, 255, 255, .1);
                                /* padding: 100%; */
                                /* margin: 10px; */
                                cursor: pointer;

                                transition: .1s;
                                
                            }
                            

                            }
                        }
                    :nth-child(1){
                        /* text-align: left;
                        padding-left: 20px; */
                        width: 20%;
                    }
                    

                }
            }

            #expandedTd-fold{
                height: 0px;
                opacity: 1;
                border: none;

                /* transition: height .8s cubic-bezier(0.000, 0.950, 0.800, 1); */
                
                padding: 0px;
                background-color: rgba(155, 155, 155, .2);
            }

            #expandedTd{
                height: 110px;
                opacity: 1;

                /* animation: bgopa .5s 1s forwards; */

                /* transition: height .8s cubic-bezier(0.000, 0.950, 0.800, 1); */
                /* transition: opacity 1s ease-out; */

                background-color: rgba(150, 150, 150, 0.2);

                >div{
                    display: flex;
                    /* align-items: center; */
                    justify-content: center;

                    span{
                        /* display: flex; */
                        /* position: relative; */
                        /* align-items: center;
                        justify-content: center; */

                        /* border: solid 1px red; */
                        
                        height: 110px;
                        width: 20%;

                        
                        div{
                            display: inline-block;
                            /* border: blue 1px solid; */
                        }
                        
                        button{
                            padding: 7px;
                            border: 1px solid rgba(150, 150, 150, 0.4);
                            border-radius: 10px;
                            color: white;
                            cursor: pointer;
                            background-color: transparent;
                            transition: .2s;
                            :hover{
                                background-color: rgba(150, 150, 150, 0.2);
                            }
                            :active{
                                background-color: rgba(150, 150, 150, 0.4);
                            }
                        }
                    }
                }
            }

            
            #OXWidth{
                max-width: 6rem;
                th{
                    max-width: 6rem;
                }
            }

            th,
            td {
                span{
                    user-select: none;
                }

                input{
                    /* background-color: transparent; */
                    border: 1px solid grey !important;
                    border-radius: 5px;
                    padding: 2px;
                    color: white;
                    width: 100%;
                    background-color:rgba(255, 255, 255, .05);
                    /* max-width: 120px; */
                }
                select{
                    background-color:rgba(255, 255, 255, .05);
                    border: 1px solid grey !important;
                    border-radius: 5px;
                    color: white;
                    padding: 2px;
                    width: 100%;
                    cursor: pointer;

                    option{
                        border: none;
                        background-color: rgba(0, 0, 0, 0.8);
                        transition: .2s;
                    }
                }
            }
    }
    }
`